module.exports = __webpack_public_path__ + "static/img/15.2642077.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/15.png
// module id = Cuy4
// module chunks = 0